module.exports = __webpack_public_path__ + "static/trig_chart_zoom-ab793effbbae344dbb9b7a9b66dffd4f.png";